import React from 'react'
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import "../../../Assets/css/junghans.css"
import DeskBanner from "../../../Assets/images/watches/jung/desk-banner.png"
import MobileBanner from "../../../Assets/images/watches/jung/mobile-banner.png"
import { isMobile } from 'react-device-detect';
import { Link } from "react-router-dom";
import img1 from "../../../Assets/images/watches/jung/jung1.png"
import img2 from "../../../Assets/images/watches/jung/jung2.png"
import img3 from "../../../Assets/images/watches/jung/jung3.png"
import img4 from "../../../Assets/images/watches/jung/jung4.png"

import item1 from "../../../Assets/images/watches/jung/item1.png"
import item2 from "../../../Assets/images/watches/jung/item2.png"
import item3 from "../../../Assets/images/watches/jung/item3.png"

import ImgItem1 from "../../../Assets/images/watches/jung/gents.png"
import ImgItem2 from "../../../Assets/images/watches/jung/ledies.png"
import ImgItem3 from "../../../Assets/images/watches/jung/collection.png"

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Junghans() {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        accessibility: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            },
        ]
    };
    return (
        <>
            <section>
                <div className="jung-watches-banner-section"
                    style={{
                        backgroundImage: `url(${isMobile ? MobileBanner : DeskBanner})`,
                    }}
                >
                    <div className="jung-watches-banner-overlay">
                        <Container>
                            <Row>
                                <Col lg={4} sm={6} xs={12} className="m-custom-auto ">
                                    <div className="jung-watches-banner-content">
                                        <h2 className="jung-watches-banner-title">Meister S {isMobile ? "" : <br />} Quarz 35</h2>
                                        <p className="jung-watches-banner-subtitle">
                                            Self-assured, sporty, strong!
                                        </p>
                                        <Button
                                            as={Link}
                                            to="/watches-list/Junghans" variant="light" className="jung-watches-banner-btn">
                                            Shop Now
                                        </Button>
                                    </div>
                                </Col>
                            </Row>

                        </Container>
                    </div>
                </div>
            </section>

            <section className='jung_section2'>
                <Container className="watches_container_jung">
                    <Row>


                        {[
                            { name: "JUNGHANS from", ImgUrl: img1, link: "/watches-list/Junghans" },
                            { name: "JUNGHANS Max Bill", ImgUrl: img2, link: "/watches-list/Junghans" },
                            { name: "JUNGHANS Meister", ImgUrl: img3, link: "/watches-list/Junghans" },
                            { name: "JUNGHANS solar radio-controlled", ImgUrl: img4, link: "/watches-list/Junghans" },
                        ].map((item, index) => (
                            <Col lg={6} sm={6} xs={12}>
                                <div className='jung_box_item'>
                                    <img src={item.ImgUrl}
                                        alt={item.name} />
                                    <div className='jung_box_title'>
                                        <Link to={item.link}>    <h2> {item.name} </h2> </Link>
                                    </div>
                                </div>
                            </Col>
                        ))}

                    </Row>
                </Container>

            </section>


            <section className='novelties_section_jung'>
                {/* Novelties Section */}
                <Container className="watches_container_jung">

                    <Row className="g-4 justify-content-center">
                        <Col xs={12}>
                            {isMobile ? (
                                <Slider {...settings}>
                                    {[
                                        { name: "FORM A CHRONOSCOPE", ImgUrl: item1, link: '/watches-list/Junghans' },
                                        { name: "Meister Chronoscope", ImgUrl: item2, link: '/watches-list/Junghans' },
                                        { name: "max Bill Automatic Bauhaus", ImgUrl: item3, link: '/watches-list/Junghans' },
                                    ].map((item, index) => (
                                        <div key={index} className="h-100 text-center product_item_jung">
                                            <Card.Img variant="top" src={item.ImgUrl} alt={item.name} />
                                            <Card.Body>
                                                <Card.Title><Link to={item.link}> {item.name} </Link></Card.Title>
                                            </Card.Body>
                                        </div>
                                    ))}
                                </Slider>
                            ) :
                                (
                                    <Row className="g-4 justify-content-center">
                                        {[
                                            { name: "FORM A CHRONOSCOPE", ImgUrl: item1, link: '/watches-list/Junghans' },
                                            { name: "Meister Chronoscope", ImgUrl: item2, link: '/watches-list/Junghans' },
                                            { name: "max Bill Automatic Bauhaus", ImgUrl: item3, link: '/watches-list/Junghans' },
                                        ].map((item, index) => (
                                            <Col key={index} xs={12} sm={4} md={4} lg={3}>
                                                <div className="h-100 text-center product_item_jung">
                                                    <Link to={item.link}><Card.Img variant="top" src={item.ImgUrl} alt={item.name} /> </Link>
                                                    <Card.Body>
                                                        <Card.Title><Link to={item.link}> {item.name} </Link></Card.Title>
                                                    </Card.Body>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                )

                            }

                        </Col>
                    </Row>
                </Container >
            </section >

            <section className='jung_section_4'>
                <Container className="watches_container_jung">
                    <h2 className="title_nov_jung">Junghans watches</h2>
                    <Row>
                        {[
                            { name: "Gents", ImgUrl: ImgItem1, link: "/watches-list/Junghans" },
                            { name: "Ledies", ImgUrl: ImgItem2, link: "/watches-list/Junghans" },
                            { name: "Collection", ImgUrl: ImgItem3, link: "/watches-list/Junghans" },
                        ].map((item, index) => (
                            <Col lg={4} sm={6} xs={12}>
                                <div className='jung_bg_box'>
                                    <Link to={item.link}> <img src={item.ImgUrl} alt={item.name} /> </Link>
                                    <h2> <Link to={item.link}>  {item.name} </Link></h2>
                                </div>
                            </Col>

                        ))}

                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Junghans